import * as z from "zod";

const errorMapping = {
    // username_min_character: "ชื่อผู้ใช้งานต้องมีจำนวนตัวอักษรมากกว่า 5 ตัวขึ้นไป",
    // username_max_character: "ชื่อผู้ใช้งานต้องมีจำนวนตัวอักษรไม่เกิน 50 ตัว",
    // username_empty: "กรุณาระบุชื่อรหัสสมาชิก / เลขประจำตัวประชาชน",
    email_empty: "login.email_empty",
    email_invalid: "login.email_invalid",
    password_min_character: "login.password_min_character",
    password_empty: "login.password_empty",
};

export const signinEmailValidatorSchema = z.object({
    email: z
        .string({
            required_error: errorMapping.email_empty,
        })
        .min(1, {
            message: errorMapping.email_empty,
        })
        .regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
            message: errorMapping.email_invalid,
        }),
    password: z
        .string({
            required_error: errorMapping.password_empty,
        })
        .min(1, {
            message: errorMapping.password_empty,
        })
        .min(8, {
            message: errorMapping.password_min_character,
        })
        .max(20),
});

export type SignInEmailValidatorSchema = z.infer<typeof signinEmailValidatorSchema>;
